
import { Options } from "vue-class-component";
import { List, Icon, Popup } from "vant";
import BaseList from "@/common/BaseList";
import AppUtil from "@/util/AppUtil";
import UserVo from "@/vo/UserVo";

@Options({
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [List.name]: List,
  },
})
/**我的畅享卡 */
export default class User extends BaseList {
  reqUrl = "/zhShareStore/enioyCard/getMemberWriteoffNotesList";

  _title = "我的畅享卡";

  card = { useNum: 0, createDate: "" };

  showQr = false;

  user = UserVo.getInstance();
  mounted() {
    AppUtil.request(
      {
        url: "/zhShareStore/enioyCard/getMemberEnioyCardInfo",
        method: "post",
      },
      this.get_info
    );
  }
  get_info(res: any) {
    console.log("获取信息", res);
    this.card = res.data;
  }
  get finishedTxt() {
    return this.list.length ? "没有更多了" : "暂无使用记录";
  }
  btn_click() {
    if (this.user.cardQrUrl) {
      return (this.showQr = true);
    }
    AppUtil.request(
      { url: "/zhShareStore/enioyCard/getEnioyCardQRCode", method: "post" },
      this.get_qr,"正在生成二维码"
    );
  }
  get_qr(res: any) {
    console.log("获取到二维码", res);
    this.user.cardQrUrl = res.data;
    this.showQr = true;
  }
  use_click() {
    this.$router.push({
      path: "/enioyCard/buy",
      query: { type: 1 },
    });
  }
}
